import { useCallback } from 'react';
import { AUDIENCE_ABTESTING_STATUS } from '../../tableUtils';

const useWizard = ({ status, id, testChannels }) => {
    const shouldShowDraft = useCallback(() => {
        return !status || AUDIENCE_ABTESTING_STATUS.EDIT === status;
    }, [status]);

    const isAlreadyStarted = useCallback(() => {
        return id && ![AUDIENCE_ABTESTING_STATUS.EDIT, AUDIENCE_ABTESTING_STATUS.SCHEDULED].includes(status);
    }, [status, id]);

    const isAlreadyEnded = useCallback(() => {
        return status && AUDIENCE_ABTESTING_STATUS.COMPLETE === status;
    }, [status]);

    const isDuplicateNetworkSelected = useCallback(() => {
        return testChannels.length > 2 && testChannels.every(channel => channel.name === testChannels[0].name);
    }, [testChannels]);

    return {
        shouldShowDraft: !!shouldShowDraft(),
        isAlreadyStarted: !!isAlreadyStarted(),
        isAlreadyEnded: !!isAlreadyEnded(),
        isDuplicateNetworkSelected: !!isDuplicateNetworkSelected(),
    };
};

export default useWizard;
